/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/require-default-props */
import { Select, useTheme } from '@chakra-ui/core';
import React, { FC, useMemo, useCallback } from 'react';
import isEqual from 'lodash/isEqual';
import { FieldOptionT } from '../../types';
import { useStoreState } from '../../../../../models/hooks';

interface SelectFollowupOptionProps {
  currentOptionIdForBlock: string;
  onChange: (newSelectedOptionId: string, oldOptionIdForBlock: string) => void;
  isAdvanced?: boolean;
  allSchemaOptions: FieldOptionT[];
  allFollowUpOptionIdsInUse: string[];
}

const SelectFollowupOption: FC<SelectFollowupOptionProps> = React.memo(
  function FollowUpOptionSelectComponent({
    currentOptionIdForBlock,
    onChange,
    isAdvanced,
    allSchemaOptions,
    allFollowUpOptionIdsInUse,
  }: SelectFollowupOptionProps) {
    const language = useStoreState((state) => state.formBuilder.currentLanguage);
    const chakraTheme = useTheme();

    const selectableOptions = useMemo(() => {
      if (!allSchemaOptions) return [];
      return allSchemaOptions.filter((opt) => {
        if (opt.id === currentOptionIdForBlock) return true;
        return !allFollowUpOptionIdsInUse.includes(opt.id);
      });
    }, [allSchemaOptions, currentOptionIdForBlock, allFollowUpOptionIdsInUse]);

    const handleSelectChange = useCallback(
      (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newSelectedOptionId = e.target.value;
        if (newSelectedOptionId !== currentOptionIdForBlock) {
          onChange(newSelectedOptionId, currentOptionIdForBlock);
        }
      },
      [onChange, currentOptionIdForBlock],
    );

    if (!allSchemaOptions || allSchemaOptions.length === 0) {
      return null;
    }

    const isDisabled = isAdvanced || selectableOptions.length <= 1;

    return (
      <Select
        width="auto"
        size="sm"
        borderRadius={chakraTheme.radii.md}
        variant="filled"
        backgroundColor={chakraTheme.colors.gray[100]}
        value={currentOptionIdForBlock}
        isDisabled={isDisabled}
        onChange={handleSelectChange}
        fontSize="xs"
        mt={1}
        mb={2}
      >
        {selectableOptions.map((option) => (
          <option key={option.id} value={option.id}>
            {option.text[language] || `Option ID: ${option.id}`}
          </option>
        ))}
        {selectableOptions.length === 0 && currentOptionIdForBlock && (
          <option key={currentOptionIdForBlock} value={currentOptionIdForBlock}>
            {allSchemaOptions.find((opt) => opt.id === currentOptionIdForBlock)?.text[language] ||
              `Option ID: ${currentOptionIdForBlock}`}
          </option>
        )}
      </Select>
    );
  },
  (p, n) =>
    /* eslint-disable-next-line  */
    p.currentOptionIdForBlock === n.currentOptionIdForBlock &&
    p.isAdvanced === n.isAdvanced &&
    p.onChange === n.onChange &&
    isEqual(p.allSchemaOptions, n.allSchemaOptions) &&
    isEqual(p.allFollowUpOptionIdsInUse, n.allFollowUpOptionIdsInUse),
);

export default SelectFollowupOption;
